import { t } from 'i18next';
import { useState } from 'react';

import { CardSelectChoices, visibleCardChoices } from './ai-builder-utils';

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';

type CardChoicePickerProps = {
  choices: CardSelectChoices;
  onPick: (option: CardSelectChoices['options'][number]) => void;
};

/**
 * The choice card's list. Filtering is ours, not cmdk's: its built-in filter
 * would only search the few rows rendered, while the search must reach the
 * whole list (a Slack workspace returns up to 2000 channels).
 */
export const CardChoicePicker = ({
  choices,
  onPick,
}: CardChoicePickerProps) => {
  const [query, setQuery] = useState('');
  const { visible, hiddenCount } = visibleCardChoices(choices, query);

  return (
    <Command shouldFilter={false} className="border rounded-md bg-muted">
      <CommandInput
        value={query}
        onValueChange={setQuery}
        placeholder={t('Search: {prop}', { prop: choices.subject })}
      />
      {/* The list is already capped at the card size: the default 300px
          height, without a scrollbar, silently cut off the last option */}
      <CommandList className="max-h-none">
        <CommandEmpty>{t('No results found.')}</CommandEmpty>
        <CommandGroup>
          {visible.map((option, index) => (
            <CommandItem
              key={`${index}-${option.label}`}
              value={`${index}-${option.label}`}
              onSelect={() => onPick(option)}
            >
              {option.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
      {hiddenCount > 0 && (
        <p className="px-3 py-2 text-xs text-muted-foreground">
          {t('+{count} — refine the search', { count: hiddenCount })}
        </p>
      )}
    </Command>
  );
};
